import { Clock, DollarSign, ShieldCheck, Star, TrendingUp } from "lucide-react";
import { aiEffects } from "../data/sampleData";

const iconMap = {
  clock: Clock,
  yen: DollarSign,
  shield: ShieldCheck,
  star: Star,
};

export default function AiEffectSummary() {
  return (
    <section>
      <h2 className="section-title">AI導入効果サマリー</h2>
      <div className="effects-grid">
        {aiEffects.map((e) => {
          const Icon = iconMap[e.icon];
          return (
            <div key={e.id} className="card effect-card">
              <div className="effect-header">
                <div className="effect-icon">
                  <Icon size={20} color="#6366f1" />
                </div>
                <span className={`trend-badge ${e.trendUp ? "up" : "down"}`}>
                  <TrendingUp size={12} /> {e.trend}
                </span>
              </div>
              <div className="effect-value">{e.value}</div>
              <div className="effect-label">{e.label}</div>
              <div className="effect-desc">{e.description}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
